var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 390.703,
    height: 390.703,
    viewBox: "0 0 390.703 390.703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loupe",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1",
    "data-name": "Groupe 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M379.711,326.556,265.343,212.188c30.826-54.189,23.166-124.5-23-170.663-55.367-55.366-145.453-55.366-200.818,0s-55.366,145.452,0,200.818c46.167,46.167,116.474,53.827,170.663,23L326.554,379.713a37.588,37.588,0,1,0,53.157-53.157Zm-165.654-112.5a102,102,0,1,1,0-144.25A102.114,102.114,0,0,1,214.057,214.059Z",
    fill: "#6d6f92"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4613625647a38e5f577cb4bcb8780329.svg";
export { ForwardRef as ReactComponent };